export const skillGroups = [
  { index: "01", title: "웹 프론트엔드", items: ["React", "Vue.js", "TypeScript", "JavaScript", "HTML5", "CSS3", "Vite"] },
  { index: "02", title: "서버 및 백엔드", items: ["Spring Framework", "Node.js", "Cloudflare Workers", "REST API", "JSP"] },
  { index: "03", title: "데이터베이스", items: ["Cloudflare D1", "Oracle", "MySQL", "MariaDB", "MSSQL", "SQLite"] },
  { index: "04", title: "Android", items: ["Java", "Kotlin", "Coroutine", "RxJava", "Retrofit2", "Dagger2"] },
  { index: "05", title: "iOS", items: ["Objective-C", "Swift", "iOS SDK", "Xcode"] },
  { index: "06", title: "크로스 플랫폼", items: ["React Native", "TypeScript", "JavaScript", "Flutter"] },
  { index: "07", title: "배포 및 협업", items: ["Git", "SVN", "GitHub Actions", "Notion", "JIRA", "CI/CD"] },
  { index: "08", title: "기타", items: ["Python",  "Nexacro", "FCM", "Gemini API", "BLE", "Map SDK"] },
] as const;
